module.exports = __webpack_public_path__ + "assets/img/351645e82cd7ee471d06f05111b1a9ef.png";